import { login, loginDnb, autoLogin, loginSso } from '@/api/auth';
import VueCookies from "vue-cookies";

const userStore = {
	namespaced: true,
	state: {
		id: cleanValue(VueCookies.get("id")),
		name: cleanValue(VueCookies.get("name")),
		desc: cleanValue(VueCookies.get("desc")),
		accessToken: cleanValue(VueCookies.get("accessToken")),
		type: cleanValue(VueCookies.get("type")),
		lastLoginTime: cleanValue(VueCookies.get("lastLoginTime")),
		sNo: cleanValue(VueCookies.get("sNo")),
		permission: cleanValue(VueCookies.get("admin")),
		passwordCheck: cleanValue(VueCookies.get("passwordCheck")),
		redirectUrl: null,
		passwordStatus: cleanValue(VueCookies.get("passwordStatus")),
	},
	getters: {
		isLogin(state) {
			return state.accessToken !== undefined && state.accessToken !== '';
		},
		isAdmin(state) {
			return state.type === 'BOARD_ADMIN';
		},
		isBank(state) {
			return state.clpTyp === 'TCB_BANK';
		},
		isKrx(state) {
			return state.clpTyp === 'TCB_KRX';
		},
		isVc(state) {
			return state.clpTyp === 'TCB_VC';
		},
		getId(state) {
			return state.id;
		},
		getName(state) {
			return state.name;
		},
		getDesc(state) {
			return state.desc;
		},
		getAccessToken(state) {
			return state.accessToken;
		},
		getType(state) {
			return state.type;
		},
		getRedirectUrl(state) {
			return state.redirectUrl;
		},
		getLastLoginTime(state) {
			return state.lastLoginTime;
		},
		getSno(state) {
			return state.sNo;
		},
		isAdminUpload(state) {
			return state.permission === 'admin';
		},
		getPasswordCheck(state) {
			return state.passwordCheck;
		},
		getPasswordStatus(state) {
			return state.passwordStatus;
		},
		isPasswordTemp(state) {
			return state.passwordStatus == "TEMP";
		}
	},
	mutations: {
		SET_ID(state, userId) {
			state.userId = userId;
		},
		SET_NAME(state, name) {
			state.name = name;
		},
		SET_DESC(state, desc) {
			state.desc = desc;
		},
		SET_ACCESS_TOKEN(state, accessToken) {
			state.accessToken = accessToken;
		},
		SET_TYPE(state, type) {
			state.type = type;
		},
		SET_LAST_LOGIN_TIME(state, lastLoginTime) {
			state.lastLoginTime = lastLoginTime;
		},
		SET_REDIRECT_URL(state, url) {
			state.redirectUrl = url;
		},
		CLEAR_REDIRECT_URL(state) {
			state.redirectUrl = null;
		},
		CLEAR_ALL(state) {
			state.id = "";
			state.name = "";
			state.desc = "";
			state.accessToken = "";
			state.type = "";
			state.lastLoginTime = "";
		},
		SET_SNO(state, sNo) {
			state.sNo = sNo;
			VueCookies.set("sNo", sNo);
		},
		SET_PERMISSION(state, permission) {
			state.permission = permission;
			VueCookies.set("permission", permission);
		},
		SET_PASSWORDCHECK(state, passwordCheck) {
			state.passwordCheck = passwordCheck;
			VueCookies.set("passwordCheck", passwordCheck);
		},
		SET_PASSWORD_STATUS(state, passwordStatus) {
			state.passwordStatus = passwordStatus;
			VueCookies.set("passwordStatus", passwordStatus);
		}
	},
	actions: {
		async LOGIN({ commit }, loginUserData) {
			const { data } = await login(loginUserData);
			console.log(data);

			const date = new Date();
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');

			const lastLoginTime = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

			commit("SET_ID", cleanValue(data.data.id));
			commit("SET_NAME", cleanValue(data.data.name));
			commit("SET_DESC", cleanValue(data.data.desc));
			commit("SET_ACCESS_TOKEN", cleanValue(data.data.accessToken));
			commit("SET_TYPE", cleanValue(data.data.type));
			commit("SET_LAST_LOGIN_TIME", lastLoginTime);
			commit("SET_PASSWORD_STATUS", data.data.passwordStatus);
			VueCookies.set("id", data.data.id);
			VueCookies.set("name", data.data.name);
			VueCookies.set("desc", data.data.desc);
			VueCookies.set("accessToken", data.data.accessToken);
			VueCookies.set("type", data.data.type);
			VueCookies.set("lastLoginTime", lastLoginTime);
			VueCookies.set("passwordStatus", data.data.passwordStatus);
		},
		async LOGIN_DNB({ commit }, loginUserData) {
			const { data } = await loginDnb(loginUserData);

			const date = new Date();
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');

			const lastLoginTime = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

			commit("SET_ID", cleanValue(data.data.id));
			commit("SET_NAME", cleanValue(data.data.name));
			commit("SET_DESC", cleanValue(data.data.desc));
			commit("SET_ACCESS_TOKEN", cleanValue(data.data.accessToken));
			commit("SET_TYPE", cleanValue(data.data.type));
			commit("SET_LAST_LOGIN_TIME", lastLoginTime);

			VueCookies.set("id", data.data.id);
			VueCookies.set("name", data.data.name);
			VueCookies.set("desc", data.data.desc);
			VueCookies.set("accessToken", data.data.accessToken);
			VueCookies.set("type", data.data.type);
			VueCookies.set("lastLoginTime", lastLoginTime);
		},
		async AUTO_LOGIN({ commit }) {
			const { data } = await autoLogin();
			if (data.data == 'null') {
				return;
			}
			const date = new Date();
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');

			const lastLoginTime = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

			commit("SET_ID", cleanValue(data.data.id));
			commit("SET_NAME", cleanValue(data.data.name));
			commit("SET_DESC", cleanValue(data.data.desc));
			commit("SET_ACCESS_TOKEN", cleanValue(data.data.accessToken));
			commit("SET_TYPE", cleanValue(data.data.type));
			commit("SET_LAST_LOGIN_TIME", lastLoginTime);

			VueCookies.set("id", data.data.id);
			VueCookies.set("name", data.data.name);
			VueCookies.set("desc", data.data.desc);
			VueCookies.set("accessToken", data.data.accessToken);
			VueCookies.set("type", data.data.type);
			VueCookies.set("lastLoginTime", lastLoginTime);
		},
		async LOGIN_SSO({ commit }, loginUserData) {
			const { data } = await loginSso(loginUserData);
			console.log(data);

			const date = new Date();
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');

			const lastLoginTime = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

			commit("SET_ID", cleanValue(data.data.id));
			commit("SET_NAME", cleanValue(data.data.name));
			commit("SET_DESC", cleanValue(data.data.desc));
			commit("SET_ACCESS_TOKEN", cleanValue(data.data.accessToken));
			commit("SET_TYPE", cleanValue(data.data.type));
			commit("SET_LAST_LOGIN_TIME", lastLoginTime);

			VueCookies.set("id", data.data.id);
			VueCookies.set("name", data.data.name);
			VueCookies.set("desc", data.data.desc);
			VueCookies.set("accessToken", data.data.accessToken);
			VueCookies.set("type", data.data.type);
			VueCookies.set("lastLoginTime", lastLoginTime);
		},
		LOGOUT({ commit }) {
			commit("CLEAR_ALL");
			VueCookies.remove("id");
			VueCookies.remove("name");
			VueCookies.remove("desc");
			VueCookies.remove("accessToken");
			VueCookies.remove("type");
			VueCookies.remove("lastLoginTime");
		},
		REFRESH_USER({ commit }, data) {
			commit("SET_ACCESS_TOKEN", data.accessToken);
			VueCookies.set("accessToken", data.accessToken);
		},
	},
};

function cleanValue(value) {
	return value && value.trim() !== "" && value !== 'null' ? value : "";
}

export default userStore;
